import React,{ Component } from 'react';
import { Table } from 'reactstrap';
import { Button, FormGroup } from 'reactstrap';
import { Container, Col } from 'reactstrap';
import { Offline, Online } from "react-detect-offline";
//import InfiniteScroll from 'react-infinite-scroller';
import {AgGridReact} from 'ag-grid-react';

import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-balham.css';

//const itemsPerPage = 500;

export default class TableRow extends Component {
    constructor(props){
    	super(props);
    	this.state = {
          text: 'Sync my data',
          // hasMore: true,
          // records: itemsPerPage     
      };
      this.aggridRef = React.createRef();
      this.onPageSizeChanged = this.onPageSizeChanged.bind(this);
      this.onBtExport = this.onBtExport.bind(this);
    //  this.loadMore = this.loadMore.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps !== this.props) {
            this.setState({ text: 'Sync my data' });
        }
    }

    onPageSizeChanged(e) {
      let value = e.target.value;
      this.aggridRef.current.api.paginationSetPageSize(Number(value));
    };

    onBtExport(){
      this.aggridRef.current.api.exportDataAsExcel();
    };

    render() {
        const { rows } = this.props;
        const perPage = 10;
        if (rows.rowData && rows.rowData.length > 0) {
            return(
              <>

                <div className="ag-theme-balham" style={{height: '567px', width: '100%'}} >
                  <div className="example-header">
                      Page Size: &nbsp;
                      <select onChange={this.onPageSizeChanged} id="page-size">
                        <option value="10" selected={true}>
                          10
                        </option>
                        <option value="100">100</option>
                        <option value="500">500</option>
                        <option value="1000">1000</option>
                      </select>
                      {/* <button
                        onClick={this.onBtExport}
                        style={{ marginLeft: '25px', fontWeight: 'bold' }}
                      >
                        Export to Excel
                      </button> */}
                    </div>
                 
                    <AgGridReact
                        ref={this.aggridRef}
                        pagination={true}
                        rowHeight={50}
                        paginationPageSize={perPage}
                        columnDefs={rows.columnDefs}
                        rowData={rows.rowData}>
                    </AgGridReact>
                  </div>
              
                </>
            );
        }

        return null;
  }
}
